import RegionToggleButton from "./RegionToggleButton";
import { Doc, Id } from "#convex/_generated/dataModel.js";
import AgencyName from "./AgencyName";

export default function RegionLabel({ regions, currentRegion }: { regions: Doc<"Region">[], currentRegion: Id<"Region"> }) {
  let region = regions.find((r) => r._id === currentRegion)
  return (
      <div className="mb-8 bg-blue rounded-lg text-white">
        <p className="p-3">{region != null ? <AgencyName region={region} /> : ""} </p>
          {regions && regions.length > 1 ? 
          <RegionToggleButton regions={regions.sort((a, b) => a.name.localeCompare(b.name))} region={currentRegion} />
        : <div className="h-11">
          <p className="inline-flex justify-center gap-x-1.5 p-3 text-xs uppercase text-white">{region != null ? region.name : ""}</p>
          </div>
          }
      </div>
  )
}